<template>
  <section v-if="name === 'goodsCategoryList'" class="section">
    <div class="section-header with-border">
      设置
    </div>
    <div class="section-body">
      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="base.title" type="text"></el-input>
        </el-form-item>
        <el-form-item >
          <el-select v-model="base.category_id" placeholder="请选择" @change="selectCategory">
            <el-option
              v-for="item in categorylist"
              :key="item.category_name"
              :label="item.category_name"
              :value="item.category_id">
            </el-option>
          </el-select>
          <el-button @click="getCategoryLists">点击获取分类数据</el-button>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="base.subtitle"></el-input>
        </el-form-item>

        <el-form-item label="组件间距">
          <el-switch
            v-model="base.padded"
            active-color="#27cc6a"
            inactive-color="#efefef">
          </el-switch>
        </el-form-item>
        <el-form-item v-if="config.type === 'goods_category_list'" label="开启排行榜">
          <el-switch
            v-model="config.leaderboard"
            active-color="#27cc6a"
            inactive-color="#efefef">
          </el-switch>
        </el-form-item>
        <el-form-item label="显示价格">
          <el-switch
            v-model="config.showPrice"
            active-color="#27cc6a"
            inactive-color="#efefef">
          </el-switch>
        </el-form-item>
        <el-form-item v-if="config.type === 'goods_category_list'" label="商品列表">
            <div class="setting-item item-selected" v-for="(item, index) in data" :key="index">
              <img class="thumbnail" :src="item.imgUrl " alt="">
              <div class="">{{item.title}}</div>
              <div class="setting-remove" @click="removeItem(index)"><i class="iconfont icon-trash-alt"></i></div>
            </div>
        </el-form-item>
        <el-form-item>
          <el-button type="default" class="iconfont icon-cog banner-button-uploader" @click="setGoods"> 设置商品</el-button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import { getCategory ,getDistributorItemsList,getDistributorCategoryItemsList} from '@/api/goods'
export default {
  props: {
    res: {
      type: Object,
      default:{}
    }
  },
  components: {
    draggable
  },
  watch: {
    res: {
      deep: true,
      handler (value) {
        if (value) {
          this.setData(value)
        }
      }
    },
  },
  data () {
    return {
      name: '',
      base: {},
      config: '',
      data: [],
      items: [],
      temp: '',
      categorylist:[],
      goodslist:[],
      distributor_id:'',
    }
  },
  methods: {
    setData(val) {
      this.name = val.name
      this.base = val.base
      this.config = val.config
      this.data = val.data
    },
    getCategoryLists() {
      var that = this;
        var param = {
          distributor_id: that.distributor_id
        };
        getCategory(param).then(response => {
          that.categorylist = response.data.data;
        })
    },
    selectCategory(e) {
      this.getItemsLists();
    },
    getItemsLists() {
      var param = {
        distributor_id: this.distributor_id,
        category_id: this.base.category_id,
        page: 1,
        pageSize: 10,
        is_can_sale: true,
      };
      if (param.category_id > 0) {
        getDistributorCategoryItemsList(param).then(response => {
          if (response.data.data.list.length > 0) {
            this.goodslist = response.data.data.list
            this.goodslist.forEach((item, index) => {
              let obj = {
                imgUrl: item.pics[0],
                title: item.item_name,
                price: item.price,
                distributor_id: this.distributor_id,
                market_price: item.market_price,
                item_bn: item.item_bn,
                item_id: item.item_id,
                goodsId: item.goods_id,
                special_type:item.special_type
              }
              this.data.splice(index, 1, obj)
            })
          }
        })
      }
    },
    removeItem(index) {
      this.data.splice(index, 1)
      console.log(this.data)
    },
    setGoods() {
      this.$emit('bindGoods', this.base.category_id)
    },
    onEnd (evt) {
      this.temp = this.data[evt.oldIndex]
      this.data.splice(evt.oldIndex, 1)
      this.data.splice(evt.newIndex, 0, this.temp)
    }
  },
  mounted() {
    this.setData(this.res);
    this.distributor_id = this.$route.query.distributor_id ? this.$route.query.distributor_id :34;
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// goods_category_list.vue?1ada6570